/* ============================================================================
   MDA CART DRAWER — tiroir panier maison (remplace UpCart)
   ----------------------------------------------------------------------------
   - Ouvre le tiroir à l'ajout au panier (interception des forms /cart/add)
     et au clic sur l'icône panier (liens /cart).
   - Items : quantités +/-, suppression, prix barrés, badges de réduction.
   - CADEAU : auto-add/retrait de la pochette (variant cfg.giftVariantId) selon
     le total APRÈS réductions vs seuil 99€ (converti en devise de présentation).
     La remise -100% est appliquée par l'automatic discount Shopify « CADEAU99 ».
   - Upsells : règles produit→produits (assets/mda-upsell-rules.json, lazy) ;
     fallback : 3 produits de la collection best-sellers.
   - Fiabilité : file d'attente (1 requête cart à la fois) + génération anti-race.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mdaCartDrawer) return;
  window.__mdaCartDrawer = true;

  var cfgEl = document.getElementById('mda-cd-config');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);

  var drawer = document.getElementById('mda-cart-drawer');
  var overlay = document.getElementById('mda-cd-overlay');
  if (!drawer || !overlay) return;

  var $ = function (sel, root) { return (root || drawer).querySelector(sel); };
  var itemsEl = $('[data-mda-cd-items]');
  var emptyEl = $('[data-mda-cd-empty]');
  var rewardsEl = $('[data-mda-cd-rewards]');
  var rewardsFillEl = $('[data-mda-cd-rewards-fill]');
  var upsellsEl = $('[data-mda-cd-upsells]');
  var upsellsHeadEl = $('[data-mda-cd-upsells-head]');
  var upsellsTrackEl = $('[data-mda-cd-upsells-track]');
  var discountsEl = $('[data-mda-cd-discounts]');
  var shipLineEl = $('[data-mda-cd-shipline]');
  var discountLabelsEl = $('[data-mda-cd-discount-labels]');
  var discountAmountEl = $('[data-mda-cd-discount-amount]');
  var checkoutEl = $('[data-mda-cd-checkout]');

  // icône étiquette (SVG net partout, remplace l'emoji 🏷 au rendu aléatoire)
  var TAG_SVG = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" style="flex:none"><path d="M20.6 13.4 11 3.8H4v7l9.6 9.6a2 2 0 0 0 2.8 0l4.2-4.2a2 2 0 0 0 0-2.8z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="7.5" cy="7.5" r="1.3" fill="currentColor"/></svg>';

  var cart = null;              // dernier état /cart.js
  var generation = 0;           // invalide les rendus périmés
  var opChain = Promise.resolve(); // file d'attente des mutations cart
  var upsellRules = null;       // lazy
  var productCache = {};        // handle -> product json
  var compareAtCache = {};      // variant_id -> compare_at_price en centimes (0 si aucun)
  var giftBusy = false;

  /* ---------- utils ---------- */
  function toPresentment(baseEur) { // seuil EUR → centimes en devise de présentation
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    return Math.round(baseEur * rate * 100);
  }
  function threshold() { return toPresentment(cfg.giftThresholdBase); }
  // Zone d'expédition du visiteur → seuil de livraison offerte + type (pour le carrousel)
  function shipCountryZone() {
    var c = ((window.Shopify && Shopify.country) || 'FR').toUpperCase();
    var low = (cfg.shipZones && cfg.shipZones.low) || { amount: 40, countries: 'FR,AD,MC' };
    var list = String(low.countries || '').toUpperCase().split(/[\s,]+/).filter(Boolean);
    if (list.indexOf(c) !== -1) {
      var isFr = (c === 'FR' || c === 'AD' || c === 'MC');
      return { amount: low.amount, kind: isFr ? 'low' : 'relay' };
    }
    return { amount: (cfg.shipZones && cfg.shipZones.high && cfg.shipZones.high.amount) || 150, kind: 'high' };
  }
  function shippingThreshold() { return toPresentment(shipCountryZone().amount); }
  function mod(name) { return !(cfg.modules && cfg.modules[name] === false); }
  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    var fmt = (cfg.moneyFormat || '{{amount_with_comma_separator}}€').replace(/<[^>]*>/g, '');
    // extraire ce qui entoure le placeholder ({{...}})
    var m = fmt.match(/^(.*)\{\{\s*[\w_]+\s*\}\}(.*)$/s);
    if (m) return (m[1] || '') + v + (m[2] || '');
    return v + '€';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + size + 'x' + size + '$1$2');
  }
  // Racine localisée (ex. "/en") : préfixe les requêtes storefront pour récupérer les
  // TITRES PRODUITS traduits (/en/cart.js, /en/products/x.js…). "" sur la langue par défaut.
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');

  // fetch interne (marqué pour ne pas être re-traité par notre patch réseau)
  function cartFetch(url, opts) {
    opts = opts || {};
    opts.headers = opts.headers || {};
    opts.headers['X-MDA-Internal'] = '1';
    // préfixe de langue pour les chemins storefront relatifs (pas les URLs d'assets CDN)
    if (ROOT && typeof url === 'string' && url.charAt(0) === '/' && url.charAt(1) !== '/') url = ROOT + url;
    return (window.__mdaOrigFetch || fetch)(url, opts);
  }
  function fetchJson(url, opts) {
    return cartFetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r.json();
    });
  }

  /* ---------- cart state ---------- */
  function refreshCart() {
    return fetchJson('/cart.js').then(function (c) { cart = c; return c; });
  }
  // /cart/change.js et /cart/clear.js renvoient le panier complet → on évite un
  // second aller-retour /cart.js. /cart/add.js ne renvoie qu'une ligne → refreshCart.
  function cartFromResponse(res) {
    if (res && typeof res.json === 'function') {
      return res.clone().json().then(function (j) {
        if (j && Array.isArray(j.items) && typeof j.total_price === 'number') { cart = j; return j; }
        return refreshCart();
      }).catch(function () { return refreshCart(); });
    }
    return refreshCart();
  }
  // Toute mutation passe par la file (1 à la fois) puis re-render + logique cadeau.
  function enqueue(mutation, opts) {
    opts = opts || {};
    var myGen = ++generation;
    if (!opts.silent) setBusy(true);
    opChain = opChain
      .then(mutation)
      .then(cartFromResponse)
      .then(function () { return ensureGift(); })
      .catch(function (e) { console.warn('[mda-cart]', e); return refreshCart().catch(function(){}); })
      .then(function () {
        if (myGen === generation) { render(); setBusy(false); }
      });
    return opChain;
  }
  function setBusy(b) { drawer.classList.toggle('is-busy', !!b); }

  /* ---------- cadeau pochette ---------- */
  // Vignettes de couleur sous la ligne offerte. Masquees si le produit n'a qu'une
  // variante disponible (rien a choisir) ou si le reglage est decoche.
  function giftPickerHtml(isGift, it) {
    if (!isGift || cfg.giftChoice === false) return '';
    var vs = (cfg.giftVariants || []).filter(function (v) { return v.available && v.image; });
    if (vs.length < 2) return '';
    var curName = '';
    vs.forEach(function (v) { if (v.id === it.variant_id) curName = v.title; });
    var lab = (cfg.text && cfg.text.giftColor) || 'Couleur';
    return '<div class="mda-cd__giftpick">' +
      '<p class="mda-cd__giftpick-lab">' + esc(lab) + (curName ? ' : <b>' + esc(curName) + '</b>' : '') + '</p>' +
      '<div class="mda-cd__giftpick-row" role="group" aria-label="' + esc(lab) + '">' +
      vs.map(function (v) {
        return '<button type="button" class="mda-cd__giftsw" data-mda-cd-gift-variant="' + v.id + '"' +
          ' aria-pressed="' + (v.id === it.variant_id ? 'true' : 'false') + '"' +
          ' aria-label="' + esc(v.title) + '" title="' + esc(v.title) + '">' +
          '<img src="' + esc(v.image) + '" alt="" width="28" height="28" loading="lazy">' +
          '</button>';
      }).join('') +
      '</div></div>';
  }

  // Echange la couleur offerte. On passe par reconcileGift : une seule passe, donc
  // jamais d'etat intermediaire ou un ajout reussi apres un retrait rate laisserait
  // deux pochettes au panier.
  function switchGiftVariant(newId) {
    if (!cart || !isGiftVariant(newId)) return Promise.resolve();
    rememberGiftId(newId);
    return reconcileGift(newId).then(function () { render(); });
  }

  // Le produit cadeau peut avoir PLUSIEURS variantes (ex. trousse Sable/Ivoire/Nuit).
  // Toutes doivent etre reconnues comme « la pochette », sinon le tiroir croit qu'il
  // manque un cadeau et en ajoute un SECOND (bug des deux pochettes de juillet).
  var GIFT_IDS = {};
  (cfg.giftVariants || []).forEach(function (v) { GIFT_IDS[String(v.id)] = 1; });
  if (cfg.giftVariantId) GIFT_IDS[String(cfg.giftVariantId)] = 1;
  function isGiftVariant(id) { return !!GIFT_IDS[String(id)]; }

  // Couleur retenue pour la visite (repli : celle reglee dans le theme).
  function chosenGiftId() {
    try {
      var v = sessionStorage.getItem('mda_gift_variant');
      if (v && GIFT_IDS[v]) return Number(v);
    } catch (e) {}
    return cfg.giftVariantId;
  }
  function rememberGiftId(id) {
    try { sessionStorage.setItem('mda_gift_variant', String(id)); } catch (e) {}
  }

  // Le produit cadeau a PLUSIEURS variantes : le panier peut donc porter plusieurs
  // lignes cadeau de couleurs differentes. On les collecte TOUTES (ne jamais se
  // contenter de la premiere : c'est ce qui a laisse passer la commande #10644).
  function giftLines() {
    var out = [];
    if (!cart) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftVariant(cart.items[i].variant_id)) out.push(cart.items[i]);
    }
    return out;
  }
  function giftLine() {
    var l = giftLines();
    return l.length ? l[0] : null;
  }

  // Total servant au seuil = total panier apres reductions, HORS lignes cadeau.
  function totalForThreshold() {
    if (!cart) return 0;
    var t = cart.total_price;
    var lines = giftLines();
    for (var i = 0; i < lines.length; i++) t -= lines[i].final_line_price;
    return t;
  }

  // Seuil de la TROUSSE : sans la carte cadeau (dématérialisée, rien à expédier). La livraison garde totalForThreshold().
  function totalForGift() {
    var t = totalForThreshold();
    if (!cart) return t;
    (cart.items || []).forEach(function (it) { if (it.gift_card) t -= it.final_line_price; });
    return t;
  }

  /* Remet les lignes cadeau dans l'etat voulu, en un seul /cart/update.js :
       - sous le seuil            : toutes les lignes cadeau a 0
       - au-dessus du seuil       : une seule ligne, quantite 1, les autres a 0
       - couleur voulue absente   : les autres a 0, puis ajout de la bonne
     forcedId = couleur explicitement demandee par la cliente (clic sur une vignette).
     Sans forcedId on garde la couleur deja au panier : on ne change rien dans son dos. */
  function reconcileGift(forcedId) {
    if (!mod('gift')) return Promise.resolve();
    if (!cart || giftBusy) return Promise.resolve();

    var lines = giftLines();
    var eligible = totalForGift() >= threshold();
    var updates = {};
    var addId = null;
    var i;

    if (eligible) {
      var wanted = forcedId || (lines.length ? lines[0].variant_id : chosenGiftId());
      var present = false;
      for (i = 0; i < lines.length; i++) {
        var keep = String(lines[i].variant_id) === String(wanted);
        if (keep) present = true;
        updates[lines[i].variant_id] = keep ? 1 : 0;
      }
      if (!present) addId = wanted;
    } else {
      for (i = 0; i < lines.length; i++) updates[lines[i].variant_id] = 0;
    }

    // Rien a corriger : on ne touche pas au panier (evite un aller-retour inutile).
    var aFaire = !!addId;
    for (i = 0; i < lines.length; i++) {
      if (lines[i].quantity !== updates[lines[i].variant_id]) aFaire = true;
    }
    if (!aFaire) return Promise.resolve();

    giftBusy = true;
    var chain = Promise.resolve();
    if (lines.length) {
      chain = chain.then(function () {
        return cartFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      });
    }
    if (addId) {
      chain = chain.then(function () {
        return cartFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: addId, quantity: 1, properties: { _mda_gift: '1' } })
        });
      });
    }
    return chain
      .then(function () { return refreshCart(); })
      .catch(function (e) { console.warn('[mda-cart] gift', e); })
      .then(function () { giftBusy = false; });
  }

  function ensureGift() { return reconcileGift(null); }

  /* ---------- date de livraison estimée ----------
     Réplique le calcul du bloc « délai de livraison » des fiches produit
     (theme.liquid) : FR 2-3 j ouvrés, Europe 4-7, monde 7-13 ; commande après
     11h = J+1 ; week-ends + fériés FR + dates exclues non comptés.
     ⚠️ Si les délais changent dans theme.liquid, les changer ici aussi. */
  function deliveryRange() {
    // ⚠️ COPIE FIDÈLE du bloc « délai de livraison » de layout/theme.liquid (fiches produit).
    // Modèle : commande → jour de PRÉPARATION (atelier) → expédition → TRANSPORT → livraison.
    // Samedi : l'atelier ne prépare pas, mais le transporteur livre.
    // Si Jordan modifie ces valeurs dans theme.liquid, les répliquer ICI.
    var PREPARATION = { MIN: 1, MAX: 1 };
    var SAMEDI_PREPARATION = false;
    var FR = { MIN: 1, MAX: 3 }, EU = { MIN: 3, MAX: 6 }, WORLD = { MIN: 6, MAX: 12 };
    var SAMEDI_LIVRAISON = true;
    var LIMIT = 11;
    var JOURS_EXCLUS = ['2026-07-03'];
    var EUC = {AL:1,AD:1,AT:1,BA:1,BE:1,BG:1,BY:1,CH:1,CY:1,CZ:1,DE:1,DK:1,EE:1,ES:1,FI:1,FO:1,GB:1,GE:1,GI:1,GR:1,HR:1,HU:1,IE:1,IS:1,IT:1,LI:1,LT:1,LU:1,LV:1,MC:1,MD:1,ME:1,MK:1,MT:1,NL:1,NO:1,PL:1,PT:1,RO:1,RS:1,RU:1,SE:1,SI:1,SK:1,SM:1,UA:1,VA:1,XK:1};
    function paques(an){var a=an%19,b=Math.floor(an/100),c=an%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mois=Math.floor((h+l-7*m+114)/31),jour=((h+l-7*m+114)%31)+1;return new Date(an,mois-1,jour);}
    function key(d){ return d.getFullYear()+'-'+d.getMonth()+'-'+d.getDate(); }
    function feriesDe(an){var p=paques(an);var lp=new Date(p);lp.setDate(p.getDate()+1);var asc=new Date(p);asc.setDate(p.getDate()+39);var lpe=new Date(p);lpe.setDate(p.getDate()+50);return [new Date(an,0,1),lp,new Date(an,4,1),new Date(an,4,8),asc,lpe,new Date(an,6,14),new Date(an,7,15),new Date(an,10,1),new Date(an,10,11),new Date(an,11,25)];}
    var AN=(new Date()).getFullYear(), FERIES={}, EXCLUS={};
    feriesDe(AN).concat(feriesDe(AN+1)).forEach(function(d){ FERIES[key(d)]=true; });
    JOURS_EXCLUS.forEach(function(s){ var p=s.split('-'); EXCLUS[(+p[0])+'-'+((+p[1])-1)+'-'+(+p[2])]=true; });
    function jourValide(d){
      if(d.getDay()===0) return false;
      if(FERIES[key(d)]) return false;
      if(EXCLUS[key(d)]) return false;
      return true;
    }
    function ouvreAtelier(d){ if(!jourValide(d)) return false; if(d.getDay()===6 && !SAMEDI_PREPARATION) return false; return true; }
    function ouvreLivraison(d){ if(!jourValide(d)) return false; if(d.getDay()===6 && !SAMEDI_LIVRAISON) return false; return true; }
    function ajouter(date,n,ouvre){ var d=new Date(date.getTime()),a=0; while(a<n){ d.setDate(d.getDate()+1); if(ouvre(d)) a++; } return d; }
    var c=((window.Shopify&&Shopify.country)||'FR').toUpperCase();
    var Z = c==='FR' ? FR : (EUC[c] ? EU : WORLD);
    var maintenant=new Date(), depart=new Date();
    if(maintenant.getHours()>=LIMIT || !ouvreAtelier(maintenant)){ depart = ajouter(depart, 1, ouvreAtelier); }
    var expMin = ajouter(depart, PREPARATION.MIN, ouvreAtelier);
    var expMax = ajouter(depart, PREPARATION.MAX, ouvreAtelier);
    var deb = ajouter(expMin, Z.MIN, ouvreLivraison);
    var fin = ajouter(expMax, Z.MAX, ouvreLivraison);
    var locale=(window.Shopify&&Shopify.locale)||'fr';
    var opt={weekday:'short',day:'numeric',month:'short'};
    try { return new Intl.DateTimeFormat(locale,opt).formatRange(deb,fin); }
    catch(e){ try { return new Intl.DateTimeFormat('fr',opt).formatRange(deb,fin); } catch(e2){ return null; } }
  }

  /* ---------- stock réel des articles (urgence authentique) ---------- */
  var stockMap = {};
  function resolveStock() {
    if (!mod('stockUrgency')) { stockMap = {}; return Promise.resolve(); }
    return cartFetch('/?section_id=mda-cart-stock')
      .then(function (r) { if (!r.ok) throw new Error('stock section'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('mda-cart-stock-data');
        stockMap = el ? JSON.parse(el.textContent) : {};
      })
      .catch(function () { stockMap = {}; });
  }

  /* ---------- rendu ---------- */
  // compare-at catalogue (prix barrés soldes) : /cart.js ne le fournit pas → on le
  // résout par produit (cache) pour afficher « 35,00€ barré → 29,75€ » comme UpCart.
  function resolveCompareAts() {
    if (!cart) return Promise.resolve();
    var missing = {};
    cart.items.forEach(function (it) {
      if (compareAtCache[it.variant_id] === undefined) missing[it.handle] = 1;
    });
    var handles = Object.keys(missing);
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      return getProduct(h).then(function (p) {
        (p.variants || []).forEach(function (v) { compareAtCache[v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    }));
  }

  function render() {
    if (!cart) return;
    // Peinture immédiate : les prix de /cart.js sont déjà justes → on n'attend RIEN.
    renderRewards();
    renderSummary();
    renderItems();
    renderUpsells();
    updateHeaderCount();
    renderDelivery();
    renderExpress();
    renderSavings();
    // Enrichissements non bloquants (prix barrés catalogue + stock) → re-rendu des items.
    var g = generation;
    Promise.all([resolveCompareAts(), resolveStock()]).then(function () {
      if (g === generation) { renderItems(); renderSavings(); }
    });
  }

  // Paiement express : visible seulement si le panier contient quelque chose
  function renderExpress() {
    var el = $('[data-mda-cd-express]');
    if (!el) return;
    el.hidden = cart.item_count === 0;
  }

  function renderDelivery() {
    var el = $('[data-mda-cd-delivery]');
    var txt = $('[data-mda-cd-delivery-text]');
    if (!el || !txt) return;
    if (cart.item_count === 0) { el.hidden = true; return; }
    var range = deliveryRange();
    if (!range) { el.hidden = true; return; }
    txt.innerHTML = esc(cfg.text.deliveryPrefix || 'Livré entre le') + ' <b>' + esc(range) + '</b>';
    el.hidden = false;
  }

  /* ---------- carrousel de réassurance (auto + navigation manuelle) ---------- */
  function initTicker() {
    var ticker = $('[data-mda-cd-ticker]');
    var track = $('[data-mda-cd-ticker-track]');
    if (!ticker || !track) return;
    // encart livraison adapté à la zone du visiteur (seuil + libellé)
    var shipSlide = $('[data-mda-cd-ticker-ship]');
    if (shipSlide) {
      var z = shipCountryZone();
      var tpl = z.kind === 'low' ? cfg.text.tickerShipLow : (z.kind === 'relay' ? cfg.text.tickerShipRelay : cfg.text.tickerShipHigh);
      shipSlide.textContent = (tpl || '').replace('[amount]', formatMoney(toPresentment(z.amount)));
    }
    var arrows = ticker.querySelectorAll('[data-mda-cd-ticker-nav]');
    var count = track.children.length;
    if (count === 0) { ticker.hidden = true; return; }          // aucun encart actif
    if (count < 2) {                                             // 1 seul encart : statique, sans flèches
      for (var a = 0; a < arrows.length; a++) arrows[a].hidden = true;
      return;
    }
    // clones aux 2 extrémités pour boucler dans les 2 sens sans à-coup
    track.appendChild(track.children[0].cloneNode(true));            // [1..n, clone(1)]
    track.insertBefore(track.children[count - 1].cloneNode(true), track.children[0]); // [clone(n), 1..n, clone(1)]
    var idx = 1; // position réelle du 1er slide
    var animating = false;
    function setX(noAnim) {
      track.style.transition = noAnim ? 'none' : 'transform .5s ease';
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }
    setX(true);
    function goTo(dir) {
      if (animating) return;
      animating = true;
      idx += dir;
      setX(false);
      setTimeout(function () {
        // ré-alignement silencieux quand on est sur un clone
        if (idx === count + 1) { idx = 1; setX(true); }
        if (idx === 0) { idx = count; setX(true); }
        animating = false;
      }, 540);
    }
    var paused = false, timer = null;
    function startTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (paused || document.hidden) return;
        goTo(1);
      }, 3500);
    }
    ticker.addEventListener('mouseenter', function () { paused = true; });
    ticker.addEventListener('mouseleave', function () { paused = false; });
    // flèches (navigation manuelle) : on relance le compte à rebours
    ticker.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mda-cd-ticker-nav]');
      if (!btn) return;
      goTo(parseInt(btn.getAttribute('data-mda-cd-ticker-nav'), 10));
      startTimer();
    });
    // swipe tactile
    var touchX = null;
    ticker.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    ticker.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 30) { goTo(dx < 0 ? 1 : -1); startTimer(); }
    }, { passive: true });
    startTimer();
  }

  var prevMs = { ship: null, gift: null }; // pour détecter le franchissement d'un palier
  function pop(el) { if (!el) return; el.classList.remove('is-celebrate'); void el.offsetWidth; el.classList.add('is-celebrate'); }
  function renderRewards() {
    var gift = mod('gift') ? threshold() : null;
    var ship = shippingThreshold();
    var cur = totalForThreshold();
    var curGift = totalForGift();
    var visible = cart.item_count > 0 && (gift || ship);
    rewardsEl.hidden = !visible;
    if (!visible) { prevMs.ship = null; prevMs.gift = null; return; }

    // Échelle de la barre = plus grand seuil actif (99€ ou 150€ selon le pays)
    var maxT = Math.max(ship || 0, gift || 0) || 1;
    rewardsFillEl.style.width = Math.max(0, Math.min(100, Math.round((cur / maxT) * 100))) + '%';

    // Jalons positionnés en % (ordre variable : FR = 40→99 ; monde = 99→150)
    [{ key: 'ship', amt: ship, tpl: cfg.text.labelShip },
     { key: 'gift', amt: gift, tpl: cfg.text.labelGift }].forEach(function (d) {
      var icon = $('[data-mda-cd-ms="' + d.key + '"]');
      var label = $('[data-mda-cd-label="' + d.key + '"]');
      if (!icon || !label) return;
      if (!d.amt) { icon.hidden = true; label.hidden = true; return; }
      var pos = Math.round((d.amt / maxT) * 1000) / 10;
      icon.hidden = false; label.hidden = false;
      icon.style.left = pos + '%';
      label.textContent = (d.tpl || '').replace('[amount]', formatMoney(d.amt));
      if (pos >= 93) { label.classList.add('at-end'); label.style.left = ''; }
      else { label.classList.remove('at-end'); label.style.left = pos + '%'; }
      icon.classList.toggle('is-complete', (d.key === 'gift' ? curGift : cur) >= d.amt);
    });

    var shipDone = ship ? cur >= ship : true;
    var giftDone = gift ? curGift >= gift : true;

    // Message dynamique : prochain palier non atteint (le plus proche)
    var msgEl = $('[data-mda-cd-rewards-msg]');
    if (msgEl && mod('messages')) {
      var cands = [];
      if (ship && !shipDone) cands.push({ amt: ship, tpl: cfg.text.msgShip, base: cur });
      if (gift && !giftDone) cands.push({ amt: gift, tpl: cfg.text.msgGift, base: curGift });
      cands.sort(function (a, b) { return a.amt - b.amt; });
      if (cands.length) {
        msgEl.innerHTML = esc(cands[0].tpl || '').replace('[amount]',
          '<span class="amount">' + formatMoney(cands[0].amt - cands[0].base) + '</span>');
      } else {
        msgEl.textContent = cfg.text.msgDone || '';
      }
      if ((prevMs.ship === false && shipDone) || (prevMs.gift === false && giftDone)) {
        pop(msgEl);
        pop(prevMs.gift === false && giftDone ? $('[data-mda-cd-ms="gift"]') : $('[data-mda-cd-ms="ship"]'));
      }
    }
    prevMs.ship = shipDone; prevMs.gift = giftDone;
  }

  function renderItems() {
    var isEmpty = cart.item_count === 0;
    emptyEl.hidden = !isEmpty;
    // retirer les anciens items rendus
    itemsEl.querySelectorAll('.mda-cd__item').forEach(function (n) { n.remove(); });
    if (isEmpty) return;

    var frag = document.createDocumentFragment();
    cart.items.forEach(function (it, idx) {
      var isGift = isGiftVariant(it.variant_id);
      var row = document.createElement('div');
      row.className = 'mda-cd__item';
      var linePrice = it.final_line_price;
      // Prix barré : réduction de ligne (ex. CADEAU99) OU compare-at catalogue (soldes)
      var unitCompare = compareAtCache[it.variant_id] || 0;
      var compareLine = null;
      if (it.original_line_price > linePrice) compareLine = it.original_line_price;
      else if (unitCompare > it.price) compareLine = unitCompare * it.quantity;
      var badges = (it.line_level_discount_allocations || []).map(function (d) {
        return d.discount_application && d.discount_application.title;
      }).filter(Boolean);

      var variantTitle = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var qtyHtml = isGift ? '' :
        '<div class="mda-cd__qty">' +
          '<button type="button" data-mda-cd-qty="-1" data-line="' + (idx + 1) + '" aria-label="Diminuer">−</button>' +
          '<span class="mda-cd__qty-val" aria-label="Quantité">' + it.quantity + '</span>' +
          '<button type="button" data-mda-cd-qty="1" data-line="' + (idx + 1) + '" aria-label="Augmenter">+</button>' +
        '</div>';

      row.innerHTML =
        '<img class="mda-cd__item-img" src="' + esc(imgUrl(it.image, 144)) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' +
        '<div>' +
          '<p class="mda-cd__item-title">' + esc(it.product_title) + '</p>' +
          (variantTitle ? '<p class="mda-cd__item-variant">' + esc(variantTitle) + '</p>' : '') +
          '<p class="mda-cd__item-price">' +
            (compareLine ? '<span class="was">' + formatMoney(compareLine) + '</span>' : '') +
            '<span class="now' + (compareLine ? '' : ' no-sale') + '">' + formatMoney(linePrice) + '</span>' +
          '</p>' +
          badges.map(function (b) {
            return '<span class="mda-cd__badge">' + TAG_SVG + ' ' + esc(b) + '</span>';
          }).join(' ') +
          giftPickerHtml(isGift, it) +
          (function () { // urgence authentique : stock réel bas
            if (isGift || !mod('stockUrgency')) return '';
            var st = stockMap[String(it.variant_id)];
            if (typeof st === 'number' && st > 0 && st <= 3) {
              return '<p class="mda-cd__stock-warn">' + esc((cfg.text.stockWarn || 'Plus que {count} en stock !').replace('[count]', st)) + '</p>';
            }
            return '';
          })() +
          qtyHtml +
        '</div>' +
        '<button type="button" class="mda-cd__remove" data-mda-cd-remove data-line="' + (idx + 1) + '" aria-label="Supprimer">' +
          '<svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M3 6h18M8 6V4h8v2m-9 0 1 14h8l1-14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>';
      frag.appendChild(row);
    });
    itemsEl.appendChild(frag);
  }

  /* ---------- ligne « Livraison » (tarifs de la page FAQ, 24/09) ---------- */
  var SHIP_EU_REST = String(cfg.shipEuRest || 'BG,HR,CY,CZ,DK,EE,FI,GR,HU,IE,LV,LT,MT,PL,RO,SK,SI,SE,CH').split(',');
  var SHIP_RATES = cfg.shipRates || [3.6, 4.9, 9.9, 14.9];
  function renderShipLine() {
    if (!shipLineEl) return;
    var sl = cfg.shipLine || {};
    if (!cart || cart.item_count === 0) { shipLineEl.hidden = true; return; }
    var c = ((window.Shopify && Shopify.country) || 'FR').toUpperCase();
    var zone = shipCountryZone();
    var tarif = SHIP_RATES[3];                              // DOM-TOM et reste du monde
    if (c === 'FR') tarif = SHIP_RATES[0];
    else if (zone.kind !== 'high') tarif = SHIP_RATES[1];   // reste de la zone 1 (seuil bas)
    else if (SHIP_EU_REST.indexOf(c) !== -1) tarif = SHIP_RATES[2];   // reste de l'UE et Suisse
    var devise = String(cart.currency || 'EUR').toUpperCase();
    // seuil converti dans la devise de la cliente : « Offerte » s'affiche aussi hors euro
    var gratuit = totalForThreshold() >= shippingThreshold();
    var val = gratuit ? (sl.free || 'Offerte')
            : devise !== 'EUR' ? (sl.calc || '')
            : (sl.from || 'Dès [amount]').replace('[amount]', formatMoney(Math.round(tarif * 100)));
    $('[data-mda-cd-shipline-label]').textContent = sl.label || 'Livraison';
    $('[data-mda-cd-shipline-value]').textContent = val;
    shipLineEl.classList.toggle('is-free', gratuit);
    shipLineEl.hidden = false;
  }

  function renderSummary() {
    renderShipLine();
    var totalDiscount = cart.total_discount || 0;
    discountsEl.hidden = !(totalDiscount > 0);
    if (totalDiscount > 0) {
      var titles = {};
      cart.items.forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (d) {
          var t = d.discount_application && d.discount_application.title;
          if (t) titles[t] = 1;
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title) titles[d.title] = 1; });
      discountLabelsEl.innerHTML = Object.keys(titles).map(function (t) {
        return '<span class="mda-cd__badge">' + TAG_SVG + ' ' + esc(t) + '</span>';
      }).join(' ');
      discountAmountEl.textContent = '- ' + formatMoney(totalDiscount);
    }
    checkoutEl.textContent = cfg.text.checkout.replace('[total]', formatMoney(cart.total_price));
    checkoutEl.setAttribute('href', ROOT + '/checkout'); // checkout dans la bonne langue
    checkoutEl.setAttribute('aria-disabled', cart.item_count === 0 ? 'true' : 'false');
  }

  // Badge « Vous économisez X€ » = remises panier (CADEAU99…) + écart soldes (compare-at).
  // compare-at chargé en asynchrone → recalculé aussi après l'enrichissement des items.
  function renderSavings() {
    var el = $('[data-mda-cd-savings]');
    if (!el) return;
    if (!mod('savings') || cart.item_count === 0) { el.hidden = true; return; }
    var save = cart.total_discount || 0;
    cart.items.forEach(function (it) {
      var ca = compareAtCache[it.variant_id] || 0;
      if (ca > it.price) save += (ca - it.price) * it.quantity;
    });
    if (save <= 0) { el.hidden = true; return; }
    var txt = $('[data-mda-cd-savings-text]');
    if (txt) txt.textContent = (cfg.text.savings || 'Vous économisez [amount]').replace('[amount]', formatMoney(save));
    el.hidden = false;
  }

  function updateHeaderCount() {
    var count = cart.item_count;
    ['[data-cart-count]', '.cart-count', '.cart-count-bubble span', '.header__cart-count', '[data-header-cart-count]']
      .forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) { el.textContent = count; });
      });
    document.dispatchEvent(new CustomEvent('mda:cart-updated', { detail: { cart: cart } }));
  }

  /* ---------- tracking « ajout au panier » (Meta / GA4 / Klaviyo) ----------
     Notre interception court-circuite le JS d'ajout du thème → ses pixels ne se
     déclenchent pas. On émet donc nous-mêmes les événements standards, UNIQUEMENT
     pour les ajouts qu'on réalise (bouton fiche, upsell, form) — pas pour les ajouts
     natifs du thème (il les track déjà) ni pour la pochette cadeau automatique. */
  function emitAddTracking(variantId, qty) {
    try {
      variantId = parseInt(variantId, 10); qty = qty || 1;
      if (!cart || !variantId) return;
      var it = null;
      for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === variantId) { it = cart.items[i]; break; } }
      if (!it) return;
      var currency = cart.currency || cfg.baseCurrency || 'EUR';
      var unit = it.price / 100;
      var value = unit * qty;

      // (A) PONT Shopify Customer Events → atteint les pixels SANDBOXÉS (Meta app,
      // GA4, Klaviyo installés via Shopify). C'est le canal réel sur ce site.
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('product_added_to_cart', {
          cartLine: {
            quantity: qty,
            cost: { totalAmount: { amount: value, currencyCode: currency } },
            merchandise: {
              id: 'gid://shopify/ProductVariant/' + it.variant_id,
              title: it.variant_title || '',
              sku: it.sku || '',
              price: { amount: unit, currencyCode: currency },
              product: {
                id: 'gid://shopify/Product/' + it.product_id,
                title: it.product_title,
                untranslatedTitle: it.product_title,
                vendor: it.vendor || '',
                url: it.url || ''
              }
            }
          }
        });
      }

      // (B) Pixels classiques dans la page (si un jour présents/initialisés) — inoffensif sinon.
      if (typeof window.fbq === 'function' && window.fbq.getState) window.fbq('track', 'AddToCart', {
        content_type: 'product', content_ids: [String(it.product_id)],
        contents: [{ id: String(it.product_id), quantity: qty }],
        value: value, currency: currency
      });
      if (typeof window.gtag === 'function') window.gtag('event', 'add_to_cart', {
        currency: currency, value: value,
        items: [{ item_id: String(it.product_id), item_name: it.product_title, price: unit, quantity: qty }]
      });
      var klProps = { $value: value, ItemName: it.product_title, ProductID: String(it.product_id), Quantity: qty, ItemPrice: unit };
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Added to Cart', klProps); // API moderne
      else if (window._learnq && typeof window._learnq.push === 'function') window._learnq.push(['track', 'Added to Cart', klProps]); // legacy
    } catch (e) { console.warn('[mda-cart] track', e); }
  }

  /* ---------- upsells ---------- */
  function loadRules() {
    if (upsellRules) return Promise.resolve(upsellRules);
    return fetchJson(cfg.upsellRulesUrl).then(function (r) { upsellRules = r; return r; })
      .catch(function () { upsellRules = []; return upsellRules; });
  }
  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetchJson('/products/' + handle + '.js').then(function (p) {
      productCache[handle] = p; return p;
    });
  }
  function pickUpsells() {
    // produits du panier (hors cadeau)
    var inCartProducts = {};
    var giftId = cfg.giftVariantId;
    cart.items.forEach(function (it) { inCartProducts[String(it.product_id)] = 1; });
    var picks = [];
    var seen = {};
    (upsellRules || []).forEach(function (rule) {
      var match = (rule.t || []).some(function (pid) { return inCartProducts[String(pid)]; });
      if (!match) return;
      (rule.u || []).forEach(function (u) {
        var handle = u[0];
        if (!handle || seen[handle]) return;
        seen[handle] = 1;
        picks.push(handle);
      });
    });
    return picks;
  }
  function setUpsellsHead(text) {
    if (!upsellsHeadEl) return;
    if (text) { upsellsHeadEl.textContent = text; upsellsHeadEl.hidden = false; }
    else upsellsHeadEl.hidden = true;
  }
  // handles récemment vus (enregistrés par le thème), toutes sources confondues
  function recentHandles() {
    try {
      var keys = Object.keys(localStorage);
      for (var i = 0; i < keys.length; i++) {
        if (!/recent/i.test(keys[i])) continue;
        var v = JSON.parse(localStorage.getItem(keys[i]));
        if (Array.isArray(v) && v.length) {
          if (typeof v[0] === 'string') return v;
          if (v[0] && v[0].handle) return v.map(function (x) { return x.handle; });
        }
      }
    } catch (e) {}
    var m = document.cookie.match(/shopify_recently_viewed=([^;]+)/);
    if (m) { try { return decodeURIComponent(m[1]).split(/[ ,]+/).filter(Boolean); } catch (e) {} }
    return [];
  }
  /* ---------- règle « petits prix » (Jordan 24/09) ----------
     Panier en euro, pays du palier à 59 €, total entre 48 € et le seuil de livraison
     offerte → bijoux à moins de 15 €, d'abord ceux qui suffisent à franchir le seuil. */
  var CHEAP = cfg.cheap || { on: true, from: 48, max: 15, collection: 'cadeaux-moins-de-20' };
  function cheapMode() {
    if (CHEAP.on === false) return false;
    if (!cart || cart.item_count === 0) return false;
    if (String(cart.currency || 'EUR').toUpperCase() !== 'EUR') return false;
    if (shipCountryZone().kind === 'high') return false;
    var t = totalForThreshold();
    return t >= CHEAP.from * 100 && t < shippingThreshold();
  }
  function renderUpsells() {
    if (!mod('upsells')) { upsellsEl.hidden = true; return; }
    if (!cheapMode()) return renderUpsellsNormal();
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.handle] = 1; });
    var gap = shippingThreshold() - totalForThreshold();
    return fetchJson('/collections/' + CHEAP.collection + '/products.json?limit=250')
      .then(function (d) {
        var suffit = [], autres = [];
        (d.products || []).forEach(function (p) {
          if (inCart[p.handle]) return;
          var v = null;
          for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
          if (!v) return;
          var prix = Math.round(parseFloat(v.price) * 100);
          if (prix >= CHEAP.max * 100) return;
          (prix >= gap ? suffit : autres).push(p.handle);
        });
        var handles = suffit.concat(autres).slice(0, cfg.maxUpsells);
        if (!handles.length) return renderUpsellsNormal();
        return Promise.all(handles.map(function (h) { return getProduct(h).catch(function () { return null; }); }))
          .then(function (prods) {
            prods = prods.filter(Boolean);
            if (!prods.length) return renderUpsellsNormal();
            setUpsellsHead(cfg.text.cheapTitle || '');
            paintUpsellTiles(prods);
          });
      })
      .catch(function () { return renderUpsellsNormal(); });
  }
  function renderUpsellsNormal() {
    if (!mod('upsells')) { upsellsEl.hidden = true; return; }
    var recoTitle = cfg.text.recoTitle || '';
    if (cart.item_count === 0) {
      // panier vide : coups de cœur récents, sinon best-sellers
      var recents = mod('recentlyViewed') ? recentHandles().slice(0, cfg.maxRecommendations) : [];
      if (recents.length) {
        return Promise.all(recents.map(function (h) { return getProduct(h).catch(function () { return null; }); }))
          .then(function (prods) {
            prods = prods.filter(Boolean);
            if (!prods.length) return renderRecommendations(recoTitle);
            setUpsellsHead(cfg.text.recentTitle || '');
            paintUpsellTiles(prods);
          });
      }
      return renderRecommendations(recoTitle);
    }
    var inCartHandles = {};
    cart.items.forEach(function (it) { inCartHandles[it.handle] = 1; });

    if ((cfg.upsellSource || 'related') === 'rules') {
      // Ancienne source : 129 règles importées d'UpCart
      loadRules().then(function () {
        var handles = pickUpsells().filter(function (h) { return !inCartHandles[h]; }).slice(0, cfg.maxUpsells);
        if (!handles.length) return renderRecommendations(recoTitle);
        return Promise.all(handles.map(function (h) { return getProduct(h).catch(function(){ return null; }); }))
          .then(function (prods) {
            prods = prods.filter(Boolean);
            if (!prods.length) return renderRecommendations(recoTitle);
            setUpsellsHead(cfg.text.upsellTitle || '');
            paintUpsellTiles(prods);
          });
      });
      return;
    }

    // Source « Produits connexes / complémentaires » = métachamps Search & Discovery,
    // lus via l'API officielle /recommendations/products.json (ta sélection curée).
    var intents = cfg.upsellSource === 'complementary' ? ['complementary']
                : cfg.upsellSource === 'both' ? ['complementary', 'related']
                : ['related'];
    var giftId = cfg.giftVariantId;
    var sources = cart.items.filter(function (it) { return !isGiftVariant(it.variant_id); });
    Promise.all(sources.map(function (it) {
      return Promise.all(intents.map(function (intent) { return fetchRecommendations(it.product_id, intent); }))
        .then(function (lists) { return [].concat.apply([], lists); });
    })).then(function (perItem) {
      var handles = [], seen = {};
      perItem.forEach(function (list) {
        list.forEach(function (p) {
          if (p && p.handle && !seen[p.handle] && !inCartHandles[p.handle]) { seen[p.handle] = 1; handles.push(p.handle); }
        });
      });
      handles = handles.slice(0, cfg.maxUpsells);
      if (!handles.length) return renderRecommendations(recoTitle);
      return Promise.all(handles.map(function (h) { return getProduct(h).catch(function () { return null; }); }))
        .then(function (prods) {
          prods = prods.filter(Boolean);
          if (!prods.length) return renderRecommendations(recoTitle);
          setUpsellsHead(cfg.text.upsellTitle || '');
          paintUpsellTiles(prods);
        });
    }).catch(function () { renderRecommendations(recoTitle); });
  }
  // Recommandations Shopify (Search & Discovery) : related = « Produits connexes »,
  // complementary = « Produits complémentaires ». On ne garde que les handles (le rendu
  // passe ensuite par getProduct pour un format de prix cohérent).
  function fetchRecommendations(productId, intent) {
    return fetchJson('/recommendations/products.json?product_id=' + productId + '&intent=' + intent + '&limit=6')
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }
  function renderRecommendations(headText) {
    fetchJson('/collections/' + cfg.bestsellersHandle + '/products.json?limit=' + (cfg.maxRecommendations + 2))
      .then(function (data) {
        var inCartHandles = {};
        (cart ? cart.items : []).forEach(function (it) { inCartHandles[it.handle] = 1; });
        var prods = (data.products || []).filter(function (p) { return !inCartHandles[p.handle]; }).slice(0, cfg.maxRecommendations);
        if (!prods.length) { upsellsEl.hidden = true; return; }
        setUpsellsHead(headText);
        // structure /collections/.../products.json ≠ /products/handle.js → normaliser
        Promise.all(prods.map(function (p) { return getProduct(p.handle).catch(function(){ return null; }); }))
          .then(function (full) { paintUpsellTiles(full.filter(Boolean)); });
      })
      .catch(function () { upsellsEl.hidden = true; });
  }
  /* Choix de la variante dans la vignette (Jordan 24/09), comme la couleur de la pochette. */
  var COULEUR = /^(couleur|coloris|color|colour|farbe|colore|cor)$/i;
  function handleize(t) {
    return String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function upsellPrice(v) {
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    return (sale ? '<span class="was">' + formatMoney(v.compare_at_price) + '</span>' : '') +
      '<span class="now' + (sale ? '' : ' no-sale') + '">' + formatMoney(v.price) + '</span>';
  }
  function upsellOptions(p, choisie) {
    if (cfg.variantChoice === false) return '';
    var dispo = p.variants.filter(function (x) { return x.available; });
    if (dispo.length < 2 || dispo.length > 8) return '';
    var options = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var photos = options.length === 1 && dispo.every(function (x) { return x.featured_image && x.featured_image.src; });
    var couleur = options.length === 1 && COULEUR.test(String(options[0] || '').trim());
    return '<div class="mda-cd__uopts" role="radiogroup">' + dispo.map(function (x) {
      var type = photos ? 'img' : couleur ? 'col' : 'txt';
      var img = x.featured_image && x.featured_image.src ? imgUrl(x.featured_image.src, 128) : '';
      var dedans = type === 'img' ? '<img src="' + esc(imgUrl(x.featured_image.src, 60)) + '" alt="" width="22" height="22" loading="lazy">'
                 : type === 'col' ? '<span class="swatches mda-cd__ucol" style="--swatch: var(--' + handleize(x.title) + ', #ccc);"></span>'
                 : esc(x.title);
      return '<button type="button" class="mda-cd__uopt mda-cd__uopt--' + type + (x.id === choisie.id ? ' is-on' : '') + '"' +
        ' role="radio" aria-checked="' + (x.id === choisie.id) + '" aria-label="' + esc(x.title) + '" title="' + esc(x.title) + '"' +
        ' data-mda-cd-opt="' + x.id + '" data-prix="' + esc(upsellPrice(x)) + '"' + (img ? ' data-img="' + esc(img) + '"' : '') + '>' +
        dedans + '</button>';
    }).join('') + '</div>';
  }
  function paintUpsellTiles(prods) {
    if (!prods.length) { upsellsEl.hidden = true; return; }
    upsellsEl.hidden = false;
    upsellsTrackEl.innerHTML = prods.map(function (p) {
      var v = null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      if (!v) return '';
      var img = (p.featured_image || (p.images && p.images[0]) || '');
      var hasSale = v.compare_at_price && v.compare_at_price > v.price;
      return '<div class="mda-cd__upsell">' +
        '<img src="' + esc(imgUrl(img, 128)) + '" alt="' + esc(p.title) + '" width="64" height="64" loading="lazy">' +
        '<div>' +
          '<p class="mda-cd__upsell-title">' + esc(p.title) + '</p>' +
          '<p class="mda-cd__upsell-price">' +
            (hasSale ? '<span class="was">' + formatMoney(v.compare_at_price) + '</span>' : '') +
            '<span class="now' + (hasSale ? '' : ' no-sale') + '">' + formatMoney(v.price) + '</span>' +
          '</p>' +
          upsellOptions(p, v) +
          '<button type="button" class="mda-cd__upsell-add" data-mda-cd-add="' + v.id + '">' + esc(cfg.text.add) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  /* ---------- ouverture / fermeture ---------- */
  // Affiche le panneau tout de suite avec l'état déjà connu (aucune attente réseau).
  function reveal() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (cart) render();
  }
  function open() {
    reveal();
    // rafraîchissement en arrière-plan ; silencieux si on a déjà du contenu à l'écran
    enqueue(function () { return Promise.resolve(); }, { silent: !!cart });
  }
  function close() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  window.mdaCartDrawer = { open: open, close: close, refresh: function () { return enqueue(function () { return Promise.resolve(); }); } };

  /* ---------- événements ---------- */
  overlay.addEventListener('click', close);
  drawer.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mda-cd-close]');
    if (t) { close(); return; }

    var giftSw = e.target.closest('[data-mda-cd-gift-variant]');
    if (giftSw) { switchGiftVariant(Number(giftSw.getAttribute('data-mda-cd-gift-variant'))); return; }

    var qtyBtn = e.target.closest('[data-mda-cd-qty]');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var delta = parseInt(qtyBtn.getAttribute('data-mda-cd-qty'), 10);
      var item = cart && cart.items[line - 1];
      if (!item) return;
      // retour visuel immédiat sur le chiffre affiché (lu depuis le DOM = correct si taps rapides)
      var valEl = qtyBtn.parentNode.querySelector('.mda-cd__qty-val');
      var shown = valEl ? parseInt(valEl.textContent, 10) : item.quantity;
      var optimistic = Math.max(0, shown + delta);
      if (valEl && optimistic > 0) valEl.textContent = optimistic;
      enqueue(function () {
        // quantité recalculée sur le panier À JOUR au moment de l'exécution
        var it = cart.items[line - 1];
        var q = Math.max(0, (it ? it.quantity : 0) + delta);
        return cartFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: q })
        });
      });
      return;
    }

    var rm = e.target.closest('[data-mda-cd-remove]');
    if (rm) {
      var l = parseInt(rm.getAttribute('data-line'), 10);
      enqueue(function () {
        return cartFetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: l, quantity: 0 })
        });
      });
      return;
    }

    var opt = e.target.closest('[data-mda-cd-opt]');
    if (opt) {
      var tuile = opt.closest('.mda-cd__upsell');
      if (!tuile) return;
      Array.prototype.forEach.call(tuile.querySelectorAll('[data-mda-cd-opt]'), function (o) {
        o.classList.remove('is-on'); o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('is-on'); opt.setAttribute('aria-checked', 'true');
      var bouton = tuile.querySelector('[data-mda-cd-add]');
      if (bouton) bouton.setAttribute('data-mda-cd-add', opt.getAttribute('data-mda-cd-opt'));
      var prixEl = tuile.querySelector('.mda-cd__upsell-price');
      if (prixEl) prixEl.innerHTML = opt.getAttribute('data-prix');
      var imgEl = tuile.querySelector(':scope > img');
      if (imgEl && opt.getAttribute('data-img')) imgEl.src = opt.getAttribute('data-img');
      return;
    }

    var add = e.target.closest('[data-mda-cd-add]');
    if (add) {
      var vid = parseInt(add.getAttribute('data-mda-cd-add'), 10);
      add.disabled = true;
      enqueue(function () {
        return cartFetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          // Étiquette « upsell » : propriété masquée au client (préfixe _) mais visible
          // dans le détail de la commande côté admin (parité UpCart).
          body: JSON.stringify({ id: vid, quantity: 1, properties: { '_Ajout': 'Suggestion panier' } })
        });
      }).then(function () { add.disabled = false; emitAddTracking(vid, 1); });
      return;
    }

    var promoBtn = e.target.closest('[data-mda-cd-promo-apply]');
    if (promoBtn) { applyPromo(); return; }

    var arrow = e.target.closest('[data-mda-cd-scroll]');
    if (arrow) {
      upsellsTrackEl.scrollBy({ left: 270 * parseInt(arrow.getAttribute('data-mda-cd-scroll'), 10), behavior: 'smooth' });
    }
  });
  // Code de réduction : Shopify n'applique les codes qu'au checkout → on redirige vers
  // /discount/CODE?redirect=/checkout (le code s'active et la remise s'affiche au paiement).
  function applyPromo() {
    var inp = $('[data-mda-cd-promo-input]');
    var code = (inp && inp.value || '').trim();
    if (!code) { if (inp) inp.focus(); return; }
    window.location.href = ROOT + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(ROOT + '/checkout');
  }
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-mda-cd-promo-input]')) { e.preventDefault(); applyPromo(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  // Interception des formulaires d'ajout au panier du thème
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopPropagation(); // éviter qu'un handler AJAX du thème ne traite AUSSI ce submit (double ajout)
    var fd = new FormData(form);
    if (!fd.get('id')) return; // pas de variant → laisser faire
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var subId = fd.get('id'), subQty = parseInt(fd.get('quantity'), 10) || 1;
    reveal(); // tiroir visible immédiatement, l'article apparaît dès la réponse
    enqueue(function () {
      return cartFetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); });
    }).then(function () {
      if (btn) btn.disabled = false;
      emitAddTracking(subId, subQty);
    });
  }, true);

  // Interception DIRECTE des boutons d'ajout du thème (déterministe : on prend la
  // main avant le JS du thème, qui selon l'état ajoute en XHR ou navigue vers /cart).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart], .product__submit__add, form[action*="/cart/add"] [type="submit"]');
    if (!btn || btn.closest('#mda-cart-drawer')) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) {
      var scope = btn.closest('product-component, product-sticky, [data-section-type]') || document;
      form = scope.querySelector('form[action*="/cart/add"][data-product-form], form[action*="/cart/add"]');
    }
    if (!form) return; // pas de formulaire → laisser le thème gérer
    var fd = new FormData(form);
    if (!fd.get('id')) return;
    if (btn.hasAttribute('disabled') || btn.classList.contains('is-loading')) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    var clkId = fd.get('id'), clkQty = parseInt(fd.get('quantity'), 10) || 1;
    reveal(); // tiroir visible immédiatement, l'article apparaît dès la réponse
    enqueue(function () {
      return cartFetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); });
    }).then(function () { emitAddTracking(clkId, clkQty); });
  }, true);

  // Interception des liens vers /cart (icône panier)
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var path = href.split('?')[0].replace(/\/$/, '');
    if (path === '/cart' || /\/[a-z]{2}(-[a-z]{2})?\/cart$/i.test(path)) {
      e.preventDefault();
      open();
    }
  }, true);

  /* ---------- interception réseau (couvre les ajouts faits PAR LE THÈME) ----------
     Le thème utilise form.submit() programmatique (ne déclenche pas l'event submit)
     et des fetch construits dynamiquement → on patche les deux. Nos propres appels
     portent le header X-MDA-Internal et sont ignorés ici. */
  var origFetch = window.fetch.bind(window);
  window.__mdaOrigFetch = origFetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var internal = false;
    try {
      var h = (init && init.headers) || (input && input.headers);
      if (h) internal = h['X-MDA-Internal'] === '1' || (h.get && h.get('X-MDA-Internal') === '1');
    } catch (e) {}
    var p = origFetch(input, init);
    var path = String(url).split('?')[0];
    if (!internal && /\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(path)) {
      var isAdd = url.indexOf('/cart/add') !== -1;
      p.then(function (res) {
        if (!res.ok) return;
        setTimeout(function () {
          enqueue(function () { return Promise.resolve(); }).then(function () { if (isAdd) open(); });
        }, 60);
      }).catch(function () {});
    }
    return p;
  };

  // Patch XMLHttpRequest (le thème utilise XHR pour ses ajouts AJAX)
  var origXhrOpen = XMLHttpRequest.prototype.open;
  var origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mdaCartUrl = String(url || '');
    return origXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var path = (this.__mdaCartUrl || '').split('?')[0];
    if (/\/cart\/(add|change|update|clear)(\.js|\.json)?$/.test(path)) {
      var isAdd = path.indexOf('/cart/add') !== -1;
      this.addEventListener('load', function () {
        if (this.status < 200 || this.status >= 300) return;
        setTimeout(function () {
          enqueue(function () { return Promise.resolve(); }).then(function () { if (isAdd) open(); });
        }, 60);
      });
    }
    return origXhrSend.apply(this, arguments);
  };

  var origSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    var action = this.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== -1) {
      var fd = new FormData(this);
      if (fd.get('id')) {
        var fsId = fd.get('id'), fsQty = parseInt(fd.get('quantity'), 10) || 1;
        enqueue(function () {
          return cartFetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); });
        }).then(function () { open(); emitAddTracking(fsId, fsQty); });
        return;
      }
    }
    return origSubmit.apply(this, arguments);
  };

  // Premier chargement : synchroniser l'état (badge compteur + cadeau si le panier
  // a été modifié ailleurs), sans ouvrir le tiroir.
  initTicker();
  refreshCart().then(function () { return ensureGift(); }).then(render).catch(function(){});

  /* Colle le haut de page : supprime l'écart fantôme (~17px) au-dessus de la barre
     d'annonce, de façon ADAPTATIVE → fonctionne sur desktop ET mobile sans jamais
     sur-corriger. Le CSS pose déjà -17px (desktop, sans clignotement) ; ce JS affine
     à la valeur exacte de l'écran courant. */
  function alignTopFlush() {
    try {
      if (window.scrollY > 4) return; // ne mesurer qu'en haut de page
      var container = document.querySelector('body > .container');
      var ann = document.querySelector('.announcement__wrapper') || document.querySelector('[id*="announcement"]');
      if (!container || !ann) return;
      var cur = parseFloat(getComputedStyle(container).marginTop) || 0;
      var annTop = ann.getBoundingClientRect().top;
      if (Math.abs(annTop) > 0.5 && Math.abs(annTop) < 60) {
        container.style.marginTop = (cur - annTop) + 'px'; // vise annTop = 0
      }
    } catch (e) {}
  }
  alignTopFlush();
  window.addEventListener('load', alignTopFlush);
  var __alignT;
  window.addEventListener('resize', function () { clearTimeout(__alignT); __alignT = setTimeout(alignTopFlush, 150); });
})();
